import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../lib/AuthContext";
export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", company: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setSubmitting(true);
    const res = await register(form);
    setSubmitting(false);
    if (res.ok) navigate("/audit/new", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16 relative" data-testid="signup-page">
      <Helmet>
        <title>Create account · The Entity Agency</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <div
        aria-hidden
        className="absolute -top-40 left-1/4 w-[400px] h-[400px] rounded-full opacity-[0.05] pointer-events-none"
        style={{ background: "radial-gradient(circle at center, #b8963e 0%, transparent 60%)" }}
      />
      <div className="w-full max-w-md relative">
        <p className="overline">Create account</p>
        <h1 className="mt-3 font-serif-display text-5xl text-[#f4efe6]" style={{fontWeight: 700}}>
          Start your <em className="text-[#b8963e] italic font-normal">snapshot.</em>
        </h1>
        <p className="mt-4 text-sm text-[#c9bca4]">
          We require a quick account so we can save your reports and let you download branded PDFs.
        </p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="overline-soft">Full name</label>
            <input type="text" required data-testid="signup-name-input"
                   value={form.name} onChange={update("name")}
                   className="mt-2 eav-input" placeholder="Alex Carter" />
          </div>
          <div>
            <label className="overline-soft">Work email</label>
            <input type="email" required data-testid="signup-email-input"
                   value={form.email} onChange={update("email")}
                   className="mt-2 eav-input" placeholder="alex@company.com" />
          </div>
          <div>
            <label className="overline-soft">Company (optional)</label>
            <input type="text" data-testid="signup-company-input"
                   value={form.company} onChange={update("company")}
                   className="mt-2 eav-input" placeholder="Acme Inc." />
          </div>
          <div>
            <label className="overline-soft">Password</label>
            <input type="password" required minLength={8} data-testid="signup-password-input"
                   value={form.password} onChange={update("password")}
                   className="mt-2 eav-input" placeholder="Min. 8 characters" />
          </div>
          {error && (
            <div data-testid="signup-error" className="text-sm text-[#c46a5a] bg-[#c46a5a]/10 border border-[#c46a5a]/30 rounded-md px-3 py-2">
              {error}
            </div>
          )}
          <button type="submit" disabled={submitting}
                  data-testid="signup-submit-button"
                  className="w-full h-12 btn-gold justify-center">
            {submitting ? "Creating account…" : "Create account & continue"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#8a7e6d]">
          Already registered?{" "}
          <Link to="/login" data-testid="signup-to-login" className="text-[#b8963e] hover:text-[#d4ae4a]">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
